// The scroll padding is only defined when the container is a
// `PageSecondaryHeaderOverflowScroll`, so `TabLinks` falls back to `0px`.
export const pageSecondaryHeaderTabContainerStyles = [
  "[--page-secondary-header-tab-container-inset:var(--page-secondary-header-overflow-scroll-padding,0px)]",
  // Overlap the header's bottom border with the active tab's border
  "-mb-[calc(var(--page-header-padding)+var(--page-secondary-header-tab-container-inset)+var(--page-header-bottom-border-width))]",
  "mt-[calc(var(--page-secondary-header-tab-container-inset)*-1)]",
  "@xl/page-header:mt-[calc(-0.5rem_-_var(--page-secondary-header-tab-container-inset))]",
  // Keep the header at its `min-h-16` height, with the tabs flush to the bottom
  "@6xl/page-header:mt-[calc(var(--page-header-padding)_-_var(--page-header-bottom-border-width)_-_var(--page-secondary-header-tab-container-inset))]"
]
